import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const MobileMenu = ({ isVisible, toggleMenu, menuItems }) => {
    const [metaData, setMetaData] = useState({});
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [notification, setNotification] = useState({ message: "", type: "" });
    const [openDropdown, setOpenDropdown] = useState(null); // 👈 NEW

    const showNotification = (message, type = "success") => {
        setNotification({ message, type });
        setTimeout(() => {
            setNotification({ message: "", type: "" });
        }, 1000);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get("/business-settings");
                setSettings(response.data.data.data);
            } catch (err) {
                setError(err);
                showNotification("Failed to load business settings.", "error");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (Array.isArray(settings)) {
            const meta = {};
            settings.forEach((setting) => {
                if (setting.type === "header_logo_path") {
                    meta.header_logo_path = setting.value;
                }
                if (setting.type === "footer_logo_path") {
                    meta.footer_logo_path = setting.value;
                }
                if (setting.type === "contact_address") {
                    meta.contact_address = setting.value;
                }
                if (setting.type === "website_name") {
                    meta.website_name = setting.value;
                }
                if (setting.type === "contact_phone") {
                    meta.contact_phone = setting.value;
                }
                if (setting.type === "contact_email") {
                    meta.contact_email = setting.value;
                }
                if (setting.type === "facebook_link") {
                    meta.facebook_link = setting.value;
                }
                if (setting.type === "twitter_link") {
                    meta.twitter_link = setting.value;
                }
                if (setting.type === "instagram_link") {
                    meta.instagram_link = setting.value;
                }
                if (setting.type === "linkedin_link") {
                    meta.linkedin_link = setting.value;
                }
            });
            setMetaData(meta);
        }
    }, [settings]);

    const handleDropdownToggle = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    if (!isVisible) return null;

    if (loading) {
        return (
            <section className="checkout">
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "300px" }}
                >
                    <div className="custom-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return <div>Error loading data</div>;
    }

    return (
        <div className="mobile-menu">
            <div className="menu-backdrop" onClick={toggleMenu}></div>
            <nav className="menu-box">
                <div className="upper-box">
                    <Link to="/">
                        <div className="nav-logo">
                            <img
                                src={metaData.footer_logo_path || "/path/to/default/logo.png"}
                                alt={metaData.website_name || "Website"}
                            />
                        </div>
                    </Link>
                    <div className="close-btn" onClick={toggleMenu}>
                        <i className="icon fa fa-times text-white"></i>
                    </div>
                </div>

                {/* ✅ Navigation with Dropdown Logic */}
                <ul className="navigation clearfix">
                    {[
                        menuItems.find(item => item.title === "Dry Fruits"), // Dry Fruits first
                        ...menuItems.filter(item => item.title !== "Dry Fruits") // baki items
                    ].map((item, index) => (
                        <li
                            key={index}
                            className={`menu-item ${item.subMenu && item.subMenu.length > 0 ? "dropdown" : ""} ${openDropdown === index ? "open" : ""}`}
                        >
                            {item.subMenu && item.subMenu.length > 0 ? (
                                <>
                                    <span
                                        onClick={() => handleDropdownToggle(index)}
                                        className="dropdown-toggle-menu-btn"
                                        style={{
                                            display: "flex",
                                            justifyContent: "start",
                                            alignItems: "center",
                                            gap: "20px",
                                            cursor: "pointer",
                                            padding:"10px 20px"
                                        }}
                                    >
                                        {item.title}
                                        <i
                                            className="fa fa-chevron-down"
                                            style={{
                                                transition: "transform 0.3s",
                                                transform: openDropdown === index ? "rotate(180deg)" : "rotate(0deg)",
                                            }}
                                        ></i>
                                    </span>

                                    {openDropdown === index && (
                                        <ul className="submenu" style={{ paddingLeft: "15px" }}>
                                            {item.subMenu.map((subItem, subIndex) => (
                                                <li key={subIndex} className="menu-item ps-1">
                                                    <Link to={subItem.link} onClick={toggleMenu} className="ps-0">
                                                        {subItem.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </>
                            ) : (
                                <Link to={item.link} onClick={toggleMenu}>
                                    {item.title}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>

                <ul className="social-links d-none">
                    <li>
                        <Link to={metaData.twitter_link}>
                            <i className="fab fa-twitter"></i>
                        </Link>
                    </li>
                    <li>
                        <Link to={metaData.instagram_link}>
                            <i className="fab fa-instagram"></i>
                        </Link>
                    </li>
                    <li>
                        <Link to={metaData.facebook_link}>
                            <i className="fab fa-facebook"></i>
                        </Link>
                    </li>
                    <li>
                        <Link to={metaData.linkedin_link}>
                            <i className="fab fa-linkedin-in"></i>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default MobileMenu;
